/**
 * ActorName Component
 *
 * Renders the actor of a timeline event. For entity actors (e.g. automations),
 * renders a clickable EntityBadge. For all other actors, renders bold text.
 */

import { useCallback } from 'react';

import { EntityBadge } from '@/lib/crm/components/badges/EntityBadge';
import { useOpenSlideoutOptional } from '@/lib/crm/hooks/useOpenSlideout';

import type { ActorInfo } from '../../useEventFormatters';
import { bold } from './InlineText';

export function ActorName({ actor }: { actor: ActorInfo }) {
  const openSlideout = useOpenSlideoutOptional();

  const handleClick = useCallback(() => {
    if (actor.object) {
      openSlideout?.(actor.object.entity_id);
    }
  }, [actor.object, openSlideout]);

  if (actor.object) {
    return (
      <EntityBadge
        state={{
          kind: 'data',
          data: {
            id: actor.object.entity_id,
            entityType: actor.object.entity_type_name,
            displayName: actor.object.ahoy_display_name ?? 'Unknown',
          },
        }}
        variant='inline'
        className='inline-flex align-middle'
        onClick={openSlideout ? handleClick : undefined}
      />
    );
  }
  return <>{bold(actor.name)}</>;
}
